import { Component, Prop, h } from '@stencil/core';
import { Header } from '../../navigation-structure.models';
import { getTranslatedLabel } from '../language.util';

@Component({
    tag: 'pnl-navigation-menu',
    styleUrl: 'pnl-navigation-menu.scss',
})
export class NavigationMenu {
    @Prop() locale: string;
    @Prop() navigation: Header;
    @Prop() labels;

    @Prop() searchActive = false;

    render() {
        if (this.navigation.menus.length > 0) {
            return (
                <nav
                    id="pnl-navigation-menu-container"
                    class="pnl-navigation__container"
                >
                    <ul class="pnl-navigation__list">
                        <li class="pnl-navigation__item">
                            <a
                                class="pnl-navigation__link pnl-navigation__link--home"
                                href={this.navigation.homeUrl}
                                aria-label={
                                    getTranslatedLabel(this.locale).home
                                }
                            >
                                <img
                                    class="pnl-navigation__link--replacement"
                                    src="https://cdn.postnl.nl/images/icons/svg/logo-postnl-outline.svg "
                                    alt="Home"
                                />
                                <span class="pnl-navigation__link-txt--mobile">
                                    {' '}
                                    {getTranslatedLabel(this.locale).home}
                                </span>
                            </a>
                        </li>
                        {this.navigation.menus.map((menu, index) => {
                            const className = `pnl-navigation__item ${this.searchActive ? 'hidden': 'active'}`;
                            return (
                                <li class={className}>
                                    <pnl-navigation-main-menu
                                        renderedIndex={index.toString()}
                                        locale={this.locale}
                                        menu={menu}
                                    ></pnl-navigation-main-menu>
                                </li>
                            )
                        })}
                    </ul>
                </nav>
            );
        }
    }
}
